import { Alert, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import type { TravelBooking } from '../queries';
import {
  activeOperationLabelKey,
  activeOperationSeverity,
} from '../bookingState';

export function ActiveOperationChip({
  booking,
  size = 'small',
}: {
  booking: TravelBooking;
  size?: 'small' | 'medium';
}) {
  const { t } = useTranslation();
  const labelKey = activeOperationLabelKey(booking);
  if (!labelKey) return null;

  return (
    <Chip
      size={size}
      color={activeOperationSeverity(booking.activeOperationStatus)}
      label={t(labelKey)}
    />
  );
}

export function ActiveOperationAlert({ booking }: { booking: TravelBooking }) {
  const { t } = useTranslation();
  const labelKey = activeOperationLabelKey(booking);
  if (!labelKey) return null;

  return (
    <Alert severity={activeOperationSeverity(booking.activeOperationStatus)}>
      {t(labelKey)}
    </Alert>
  );
}
